module.exports = __webpack_public_path__ + "static/media/Culata.09753dd8.jpg";